import { useEffect, useMemo } from "react";
import { Canvas, useFrame } from "@react-three/fiber";
import * as THREE from "three";

const Actor = ({ model, clip, then, yaw }) => {
  const mixer = useMemo(() => new THREE.AnimationMixer(model.scene), [model]);
  useEffect(() => {
    const a = model.clips[clip];
    if (!a) return;
    const act = mixer.clipAction(a).reset().play();
    const nxt = then && model.clips[then];
    if (!nxt) return () => act.stop();
    act.setLoop(THREE.LoopOnce, 1); act.clampWhenFinished = true;
    const done = () => { act.fadeOut(0.3); mixer.clipAction(nxt).reset().fadeIn(0.3).play(); };
    mixer.addEventListener("finished", done);
    return () => { mixer.removeEventListener("finished", done); mixer.stopAllAction(); };
  }, [clip, then, mixer, model]);
  useFrame((_, dt) => { model.root.rotation.y = yaw; mixer.update(dt); model.scene.userData.updateProp?.(); });
  return <primitive object={model.root} />;
};

/** A validated 3D character playing a library clip (e.g. Naya waving, Bao celebrating), optionally followed by another clip. */
export const Clip3D = ({ model, clip, then = null, yaw = 0, preserve = false, testId, cam = [0, 0.85, 5.6], look = 0.82 }) => (
  <div className="h-full w-full" data-testid={testId} data-clip={clip}>
    <Canvas dpr={[1, 1.5]} gl={{ alpha: true, antialias: true, preserveDrawingBuffer: preserve, toneMapping: THREE.ACESFilmicToneMapping, outputColorSpace: THREE.SRGBColorSpace }}
      camera={{ position: cam, fov: 20 }} onCreated={({ camera, gl }) => { camera.lookAt(0, look, 0); gl.setClearColor(0x000000, 0); }}>
      <hemisphereLight args={["#FFF4E0", "#8FA8A0", 1.4]} />
      <directionalLight position={[2, 4, 3]} intensity={2.2} />
      <directionalLight position={[-3, 2, -2]} intensity={1} color="#7FE3D8" />
      <Actor model={model} clip={clip} then={then} yaw={yaw} />
    </Canvas>
  </div>
);
